import React, { Component } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { Title, Overview } from 'components/misc'

const actOverviewMock = { loading: false }

class SectionOverview extends Component {
  static propTypes = {
    activity: PropTypes.object.isRequired,
    index: PropTypes.number,
    section: PropTypes.string,
    colorClass: PropTypes.string
  }

  shouldComponentUpdate(nextProps) {
    return (
      get(nextProps.activity, 'id') !== get(this.props.activity, 'id') &&
      get(nextProps.activity, 'id') > 0
    )
  }

  render() {
    const { activity, index, section, colorClass } = this.props

    return (
      <div key={activity.id}>
        <Title
          h5
          colorClass={colorClass}
          style={{ margin: 0, fontWeight: 'bold' }}
        >
          {get(activity, 'activityCategory.parent.translatedName')}
          {' - '}
          {get(activity, 'activityCategory.translatedName')}
        </Title>

        <div className="row">
          <div className="col-xs-12 col-lg-4">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={section}
              content={[
                {
                  id: index + '0',
                  content: get(activity, 'activityState.translationText'),
                  intlKey: 'label.status',
                  label: 'Status',
                  ico: 'info'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-md-6 col-lg-4">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={section}
              content={[
                {
                  id: index + '0',
                  content: get(activity, 'aim'),
                  intlKey: 'label.goal',
                  label: 'Goal',
                  ico: 'flag'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-md-6 col-lg-4">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={section}
              content={[
                {
                  id: index + '1',
                  content:
                    get(activity, 'assessorName') &&
                    `${get(activity, 'assessorTitle') || ''} ${
                      activity.assessorName
                    }`,
                  intlKey: 'label.name',
                  label: 'Name',
                  ico: 'face'
                }
              ]}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default SectionOverview
